export const useDomain = (): { peacock: boolean; default: boolean } => {
  const domains = {
    peacock: window.location.hostname.startsWith('peacock'),
  };

  return { ...domains, default: !domains.peacock };
};
